/*
 * Host strategy factory.
 * Returns the appropriate IHostStrategy based on the detected Office host type.
 */

/* global Office */

import type { IHostStrategy } from "./host-strategy";
import { ExcelHostStrategy } from "./excel/excel-host";
import { WordHostStrategy } from "./word/word-host";
import { PowerPointHostStrategy } from "./powerpoint/powerpoint-host";
import { OutlookHostStrategy } from "./outlook/outlook-host";

export function createHostStrategy(
  hostType: typeof Office.HostType[keyof typeof Office.HostType],
): IHostStrategy | null {
  switch (hostType) {
    case Office.HostType.Excel:
      return new ExcelHostStrategy();
    case Office.HostType.Word:
      return new WordHostStrategy();
    case Office.HostType.PowerPoint:
      return new PowerPointHostStrategy();
    case Office.HostType.Outlook:
      return new OutlookHostStrategy();
    default:
      return null;
  }
}
